import { render, staticRenderFns } from "./supplierCertificates.vue?vue&type=template&id=1fa6cb7e"
import script from "./supplierCertificates.vue?vue&type=script&lang=js"
export * from "./supplierCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports